import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
export function CTASection() {
  return <section className="py-20 bg-white" data-id="element-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="bg-[#1e3a5f] rounded-3xl overflow-hidden shadow-2xl relative" data-id="element-26">
          {/* Decorative circles */}
          <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 bg-[#f59e0b] rounded-full opacity-10 blur-3xl" data-id="element-27"></div>
          <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-64 h-64 bg-[#f59e0b] rounded-full opacity-10 blur-3xl" data-id="element-28"></div>

          <div className="relative z-10 px-8 py-16 md:py-20 text-center" data-id="element-29">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-30">
              Ready to Start Your Journey?
            </h2>
            <p className="text-lg text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-31">
              Book a free consultation with our education experts today and take
              the first step towards your international education.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-32">
              <Link to="/apply" className="w-full sm:w-auto" data-id="element-33">
                <Button variant="accent" size="lg" fullWidth data-id="element-34">
                  Apply Now
                </Button>
              </Link>
              <Link to="/contact" className="w-full sm:w-auto" data-id="element-35">
                <Button variant="outline" size="lg" fullWidth data-id="element-36">
                  Contact Us
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}